export const environment = {
    production: true,
	hmr       : false,
	environment:'production',
    pathConfig: 'assets/config.prod.json'
};
